import { Component, OnDestroy, OnInit } from "@angular/core";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { transition, style, animate, trigger } from "@angular/animations";
import { Subject } from "rxjs";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-header-image",
  templateUrl: "./header-image.component.html",
  styleUrls: ["./header-image.component.css", "../../app.component.css"],
  animations: [
    trigger("item", [
      transition(":enter", [
        style({ height: 0, transform: "scale(0)", opacity: 0 }),
        animate(
          "300ms 300ms",
          style({ height: "*", transform: "scale(1)", opacity: 1 })
        ),
      ]),
      transition(":leave", [
        style({ height: "*", transform: "scale(1)", opacity: 1 }),
        animate(
          "100ms 300ms",
          style({ height: 0, transform: "scale(0)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class HeaderImageComponent implements OnInit, OnDestroy {
  config;
  constructor(private um: UserManager, private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }
  profile;

  leaving = new Subject();
  ngOnInit() {
    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe((profile) => (this.profile = profile));
  }

  ngOnDestroy() {
    this.leaving.next();
  }

  onError(e) {
    console.log(e);
  }
  register() {
    this.um.openSignUpAndThenGoToLesson();
  }
  ngAfterViewChecked() { }
}
